<template>
  <div class="row">

    <!-- 🔹 COLONNE GAUCHE : AXES -->
    <div class="col-md-4 border-end">

      <h5 class="mb-3">Axes</h5>

      <button
          type="button"
          v-if="!viewMode"
          class="btn btn-primary w-100 mb-3"
          @click="createAxe"
      >
        <i class="fe fe-plus me-1"></i>
        Ajouter un axe
      </button>

      <div
          v-for="(axe, index) in value"
          :key="index"
          class="card mb-2 cursor-pointer"
          :class="{ 'bg-primary-transparent': selectedAxeIndex === index }"
          @click="selectAxe(index)"
      >
        <div class="card-body p-3">
          <strong>{{ axe.title || 'Axe sans titre' }}</strong>
        </div>
      </div>

    </div>

    <!-- 🔹 COLONNE DROITE : DÉTAIL AXE + ACTIONS -->
    <div class="col-md-8">

      <h5 class="mb-4">Détail de l’axe</h5>

      <div v-if="selectedAxeIndex === null" class="text-muted">
        Sélectionnez un axe à gauche
      </div>

      <div v-else>

        <!-- ACTIONS AXE -->
        <div class="d-flex justify-content-end gap-2 mb-4">
          <button
              type="button"
              v-if="editMode"
              class="btn btn-outline-secondary"
              @click="cancelEdit"
          >
            Ignorer
          </button>

          <button
              type="button"
              v-if="editMode"
              class="btn btn-primary"
              @click="applyAxe"
          >
            Valider
          </button>

          <button
              type="button"
              v-if="!editMode && !viewMode"
              class="btn btn-primary"
              @click="editMode = true"
          >
            Modifier
          </button>

          <button
              type="button"
              v-if="!viewMode"
              class="btn btn-outline-danger"
              @click="removeAxe"
          >
            Supprimer
          </button>
        </div>

        <!-- FORM AXE -->
        <div class="row mb-4">

          <div class="col-md-6">
            <FieldViewEdit
                label="Titre de l’axe"
                v-model="form.title"
                :viewMode="viewMode || !editMode"
                required
            />
          </div>

          <div class="col-md-12">
            <FieldViewEdit
                label="Description"
                type="textarea"
                v-model="form.description"
                :viewMode="viewMode || !editMode"
            />
          </div>

        </div>

        <!-- 🔹 ACTIONS -->
        <hr />
        <h6 class="mb-3">Actions</h6>

        <button
            type="button"
            v-if="!viewMode"
            class="btn btn-outline-primary btn-sm mb-3"
            @click="addAction"
        >
          <i class="fe fe-plus me-1"></i>
          Ajouter une action
        </button>

        <div
            v-for="(action, idx) in form.actions"
            :key="idx"
            class="card mb-2"
        >
          <div class="card-body">

            <FieldViewEdit
                label="Titre action"
                v-model="action.title"
                :viewMode="viewMode || !editMode"
                required
            />

            <FieldViewEdit
                label="Description"
                type="textarea"
                v-model="action.description"
                :viewMode="viewMode || !editMode"
            />

            <div v-if="!viewMode" class="text-end">
              <button
                  class="btn btn-outline-danger btn-sm"
                  @click="removeAction(idx)"
              >
                Supprimer
              </button>
            </div>

          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
  import FieldViewEdit from "@/components/forms/FieldViewEdit.vue";

  export default {
    name: "ProjectAxesActions",
    components: { FieldViewEdit },
    props: {
      value: {
        type: Array,
        required: true,
      },
      viewMode: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        selectedAxeIndex: null,
        form: {},
        editMode: false,
      };
    },
    methods: {
      selectAxe(index) {
        this.selectedAxeIndex = index;
        this.form = JSON.parse(JSON.stringify(this.value[index]));
        this.editMode = false;
      },
      createAxe() {
        this.selectedAxeIndex = this.value.length;
        this.form = {
          title: "",
          description: "",
          actions: [],
        };
        this.editMode = true;
      },
      applyAxe() {
        const updated = [...this.value];
        updated[this.selectedAxeIndex] = { ...this.form };
        this.$emit("input", updated);
        this.editMode = false;
      },
      removeAxe() {
        const updated = [...this.value];
        updated.splice(this.selectedAxeIndex, 1);
        this.$emit("input", updated);
        this.selectedAxeIndex = null;
      },
      cancelEdit() {
        this.form = { ...this.value[this.selectedAxeIndex] };
        this.editMode = false;
      },
      addAction() {
        this.form.actions.push({
          title: "",
          description: "",
        });
      },
      removeAction(index) {
        this.form.actions.splice(index, 1);
      },
    },
  };
</script>
